"use strict";var id=0,px=Math.random();module.exports=function(t){return"Symbol(".concat(void 0===t?"":t,")_",(++id+px).toString(36))};